import { Routes } from '@angular/router';

export const CCONFERENCE_ROUTES: Routes = [
  
  {
    path: 'conference',
    loadComponent: () =>
      import('./conference/Component/conference.component').then(
        (m) => m.ConferenceComponent,
      ),
  },
    {
    path: 'conference-details/:id',
    loadComponent: () =>
      import('./conference-details/Component/conference-details.component').then(
        (m) => m.ConferenceDetailsComponent,
      ),
  },
    {
    path: 'school',
    loadComponent: () =>
      import('./school/Component/school.component').then(
        (m) => m.SchoolComponent,
      ),
  },
    {
    path: 'school-details/:id',
    loadComponent: () =>
      import('./school-details/Component/school-details.component').then(
        (m) => m.SchoolDetailsComponent,
      ),
  }
]